import { render, staticRenderFns } from "./IssueFromSiloModal.vue?vue&type=template&id=3b7b441a&"
import script from "./IssueFromSiloModal.vue?vue&type=script&lang=js&"
export * from "./IssueFromSiloModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports